export enum JobseekerPopupEnum{
    Login = 0,
    Registration = 1,
}